import type { FilterFormValues } from '@vlabs/monokit/entities/matcher/types/types';

export const defaultFilterValues: FilterFormValues = {
  age: [],
  apparent_gender: [],
  apparent_age: [],
  areas: '',
  backpack_states: [],
  cities: '',
  deepfake: [],
  districts: '',
  emotions: [],
  event_ids: [],
  external_ids: [],
  face_ids: [],
  gender: [],
  handler_ids: [],
  headwear_states: [],
  headwear_apparent_colors: [],
  house_numbers: '',
  latitude_delta: '',
  limit: 100,
  list_id: '',
  longitude_delta: '',
  lower_garment_types: [],
  lower_garment_colors: [],
  liveness: [],
  masks: [],
  origin_longitude: '',
  origin_latitude: '',
  sources: [],
  shoes_apparent_colors: [],
  sleeve_lengths: [],
  streets: '',
  stream_ids: [],
  tags: [],
  top_matching_candidates_label: '',
  top_similar_object_ids: '',
  top_similar_object_similarity__gte: '',
  top_similar_object_similarity__lt: '',
  threshold: 0,
  order: 'similarity',
  track_ids: [],
  upper_clothing_colors: [],
  user_data: '',
};
